import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { setSection } from "../../../assignmentSlice";

import { useTTS } from "../../../../../hooks/useTTS";

import CorrectOverlay from "../../widgets/CorrectOverlay";
import VocaMatchingCard from "./VocaMatchingCard";

const VocaMatchingPage = ({
  currentPage,
  section,
  pageList,
  setPageList,
  currentIndex,
  setCurrentIndex,
  type,
  isReview = false,
}) => {
  const dispatch = useDispatch();
  const { speak } = useTTS();

  const [engList, setEngList] = useState([]);
  const [korList, setKorList] = useState([]);
  const [selectedKorIndex, setSelectedKorIndex] = useState(-1);
  const [selectedEngIndex, setSelectedEngIndex] = useState(-1);
  const [overlayVisible, setOverlayVisible] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);

  useEffect(() => {
    if (currentPage.data) {
      setEngList(
        currentPage.data
          .map((word, index) => {
            return { index: index, text: word.eng, isMatched: word.isMatched };
          })
          .sort(() => Math.random() - 0.5)
      );
      setKorList(
        currentPage.data
          .map((word, index) => {
            return { index: index, text: word.kor, isMatched: word.isMatched };
          })
          .sort(() => Math.random() - 0.5)
      );
    }
  }, [currentIndex]);

  useEffect(() => {
    if (currentPage.data && engList.length > 0) {
      const newEngList = engList.map((word) => {
        return { ...word, isMatched: currentPage.data[word.index].isMatched };
      });
      const newKorList = korList.map((word) => {
        return { ...word, isMatched: currentPage.data[word.index].isMatched };
      });
      setEngList(newEngList);
      setKorList(newKorList);

      if (currentPage.isSubmitted && currentIndex < pageList.length - 1) {
        setTimeout(() => {
          setCurrentIndex(currentIndex + 1);
        }, 800);
      }
    }
  }, [pageList]);

  const selectKor = (index) => {
    if (selectedKorIndex === index) {
      setSelectedKorIndex(-1);
    } else {
      setSelectedKorIndex(index);
      if (selectedEngIndex !== -1) {
        if (selectedEngIndex === index) {
          const newPageList = pageList.map((page, pageIndex) => {
            if (pageIndex === currentIndex) {
              return {
                ...page,
                data: page.data.map((word, wordIndex) => {
                  if (wordIndex === index) {
                    return { ...word, isMatched: true };
                  }
                  return word;
                }),
                isSubmitted: page.data
                  .filter((word, wordIndex) => wordIndex !== index)
                  .every((word) => word.isMatched),
              };
            }
            return page;
          });
          setIsCorrect(true);
          setPageList(newPageList);
          dispatch(setSection({ ...section, answer: newPageList }));
        } else {
          setIsCorrect(false);
        }
        setOverlayVisible(true);
        setTimeout(() => {
          setOverlayVisible(false);
        }, 600);
        setSelectedKorIndex(-1);
        setSelectedEngIndex(-1);
      }
    }
  };

  const selectEng = (index) => {
    if (selectedEngIndex === index) {
      setSelectedEngIndex(-1);
    } else {
      setSelectedEngIndex(index);
      if (selectedKorIndex !== -1) {
        if (selectedKorIndex === index) {
          setIsCorrect(true);
          const newPageList = pageList.map((page, pageIndex) => {
            if (pageIndex === currentIndex) {
              return {
                ...page,
                data: page.data.map((word, wordIndex) => {
                  if (wordIndex === index) {
                    return { ...word, isMatched: true };
                  }
                  return word;
                }),
                isSubmitted: page.data
                  .filter((word, wordIndex) => wordIndex !== index)
                  .every((word) => word.isMatched),
              };
            }
            return page;
          });
          setPageList(newPageList);
          dispatch(setSection({ ...section, answer: newPageList }));
        } else {
          setIsCorrect(false);
        }
        setOverlayVisible(true);
        setTimeout(() => {
          setOverlayVisible(false);
        }, 600);
        setSelectedKorIndex(-1);
        setSelectedEngIndex(-1);
      }
    }
    speak({ text: currentPage.data[index].eng });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
      }}
    >
      <div
        style={{
          fontSize: "20px",
          textAlign: "center",
          marginBottom: "60px",
        }}
      >
        올바른 단어와 뜻을 찾아 선택하세요.
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        {engList.map((eng) => (
          <VocaMatchingCard
            word={eng}
            selectedIndex={selectedEngIndex}
            handleClick={selectEng}
            type={type}
          />
        ))}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        {korList.map((kor) => (
          <VocaMatchingCard
            word={kor}
            selectedIndex={selectedKorIndex}
            handleClick={selectKor}
            type={type}
          />
        ))}
      </div>
      <div
        style={{
          opacity: overlayVisible ? 1 : 0, // Fade-in/out
          visibility: overlayVisible ? "visible" : "hidden", // DOM에서 숨김
          transition: "opacity 200ms ease-out, visibility 200ms",
        }}
      >
        <CorrectOverlay bool={isCorrect} />
      </div>
    </div>
  );
};

export default VocaMatchingPage;
